import React, { useState } from "react";
import { AboutImg, Nut } from "../../../../images/Images";
import "./ProductDetails.css";
import RatingSvg from "../../components/svgs/RatingSvg";
import GradientButton from "../../../../components/button/Button";
import CartSvg from "./svgs/CartSvg";
import ProductCard from "../../components/products/ProductsCard";

const products = [
  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },
];

export const QuantitySelector = ({
  value,
  min = 1,
  max = 20,
  onChange,
  onDelete,
}: {
  value: number;
  min?: number;
  max?: number;
  onChange: (value: number) => void;
  onDelete?: () => void;
}) => {
  const increase = () => {
    if (value < max) onChange(value + 1);
  };
  const decrease = () => {
    if (value > min) onChange(value - 1);
  };

  return (
    <div className="quantity-selector">
      {value === min ? (
        <button
          onClick={onDelete}
          style={{ color: "#f44336", background: "none" }}
        >
          x
        </button>
      ) : (
        <button onClick={decrease} disabled={value <= min}>
          -
        </button>
      )}
      <span>{value}</span>
      <button onClick={increase} disabled={value >= max}>
        +
      </button>
    </div>
  );
};

const ProductDetails: React.FC = () => {
  const [quantity, setQuantity] = useState(1); // Manage quantity state

  // Quantity Selector Component

  return (
    <div className="retail__product_details">
      <div className="product_flex">
        <div className="product__image">
          <img src={AboutImg} alt="desc image" />
        </div>

        <div className="product__desc">
          <p className="store_name">Glorious Sunshine Groceries</p>
          <p className="product_name">Waterleaf (Talinum Triangulare)</p>
          <div className="unit">
            <p className="price">$100</p> <span>per unit</span>
          </div>

          <p className="bundle">4 Bundles per Unit</p>
          <p className="desc">
            Waterleaf is known as Efo Gbure in Yoruba and is a very important
            leafy vegetable in Nigeria. Talinum fruticosum is a herbaceous
            perennial plant that is native to Mexico, the Caribbean, West
            Africa, Central America, and much of South America.
          </p>

          <div className="rate">
            <p>
              <RatingSvg />
              <RatingSvg />
              <RatingSvg />
              <RatingSvg />
              <RatingSvg />
            </p>

            <p>(142 Reviews) </p>

            <p style={{ margin: 2 }}> </p>

            <p> 20 Units Left in Stock</p>
          </div>

          {/* Quantity Selector */}
          <div className="details__btn">
            <p style={{ marginRight: 10 }}>Quantity</p>
            <QuantitySelector
              value={quantity}
              min={1}
              max={20}
              onChange={setQuantity}
            />

            <div className="btn_container">
              <GradientButton
                text={`Add ${quantity} to cart`}
                svg={<CartSvg />}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="product__likes">
        <p className="may_like">You may also like</p>
        <div className="retail-product-list__grid">
          {products.map((product, index) => (
            <ProductCard key={index} {...product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
